import React from 'react';

import DescriptionBox from '../descriptionBox/DescriptionBox';
import { Button } from '@/kaya';
import { column } from '@/config/earningTable.config';
import Table from '../table/Table';
import { songsStore, withdrawStore } from '@/store';
import { generalHelpers } from '@/helpers';
import WithDrawalPopup from '../withdrawalPopup/WithDrawalPopup';

import styles from './Earnings.module.scss';
import { MODE } from '@/axios';
import { userActions } from '@/actions';

const Earnings = () => {
  const { withdraw } = withdrawStore();
  const { songs } = songsStore();

  const [visible, setVisible] = React.useState(false);

  const STATUS_VS_FRONTENDSTATUS: { [key: string]: string } = {
    PENDING: 'PENDING',
    REJECTED: 'DECLINED',
    ACCEPTED: 'APPROVED',
    // Add more mappings as needed
  };

  const totalWithdrawal = withdraw
    .filter((item) => STATUS_VS_FRONTENDSTATUS[item.status] === 'APPROVED')
    .reduce((acc, item) => acc + item.amount, 0);

  const resultOfsong = songs
    .filter((item) => STATUS_VS_FRONTENDSTATUS[item.submission_status] === 'APPROVED')
    .reduce((acc, item) => acc + item.total_views, 0);

  const totalEarnings = resultOfsong * 0.003;
  const fallbackMinimumAmount = MODE === 'dev' ? 0.001 : 100;
  const [minimumAmount, setMinimumAmount] = React.useState<number>(fallbackMinimumAmount);

  React.useEffect(() => {
    const fetchMinAmount = async () => {
      const res = await userActions.fetchWithdrawAmountAction();
      if (res.success && typeof res.data === 'number') {
        setMinimumAmount(res.data);
      } else {
        setMinimumAmount(fallbackMinimumAmount);
      }
    };
    fetchMinAmount();
  }, [fallbackMinimumAmount]);

  const handleWithdraw = () => {
    if (totalEarnings < minimumAmount) {
      generalHelpers.toaster('warning', `Minimum withdrawal amount is $${minimumAmount}`);
      return;
    }
    setVisible(true);
  };

  return (
    <>
      <div className={styles.Earnings}>
        <Button className={styles.btn} type="Primary" onClick={handleWithdraw}>
          Withdraw
        </Button>
        <div className={styles.deatilBox}>
          <div className={styles.box1}>
            <DescriptionBox title="Your Current Earning" value={totalEarnings || 0} />
            <DescriptionBox title="Total Past Withdrawls" value={totalWithdrawal || 0} />
            <DescriptionBox
              title="Minimum Withdrawal Amount"
              value={`$${minimumAmount}`}
              width="230px"
            />
          </div>
        </div>
        <h2 className={styles.heading}>Past withdrawal</h2>
        <div className={styles.table}>
          <Table
            columns={column}
            rows={withdraw}
            disableActions
            columnnStyle={styles.columnnStyle}
          />
        </div>
      </div>
      <WithDrawalPopup visible={visible} setVisible={setVisible} />
    </>
  );
};

export default Earnings;
